import React from 'react';
import GenericPopover from "@Popover/components/GenericPopover";
import intToBool from "@Number/intToBool";
import datasetExtractor from "@Dataset/datasetExtractor";
import MTicketPopoverOverlay from "@Pages/stationToStation/features/mTicketPopover/components/MTicketPopoverOverlay";
import MTicketPopoverTrigger from "@Pages/stationToStation/features/mTicketPopover/components/MTicketPopoverTrigger";

interface MTicketPopoverProps {
    routeId?: string,
    hasETicket?: boolean | null,
    // ? is here so this can be used with PortalMap without errors
    index?: number,
}

// TODO: remove this. use existing RouteMTicket
function MTicketPopover({routeId = null, hasETicket = null, index}: MTicketPopoverProps) {
    const hasMTicket = hasETicket !== null
        ? hasETicket
        : intToBool(datasetExtractor('gb--route-ticket_type', index, 'eticket'));

    if (hasMTicket) {
        return (
            <GenericPopover
                id={`m-ticket-popover-${index ?? routeId}`}
                overlay={<MTicketPopoverOverlay/>}
                trigger={<MTicketPopoverTrigger/>}
            />
        );
    }

    return null
}

export default MTicketPopover